import CustomerOrderLineItemsTable from "../CustomerOrdersTable/CustomerOrderLineItemsTable";
import OrderShipmentsTable from "../OrderShipmentsTable/OrdersShipmentsTable";

export const OrderTabs = [
    { id: 1, label: "Line Items", TableComponent: CustomerOrderLineItemsTable },
    { id: 2, label: "Shipments", TableComponent: OrderShipmentsTable }
]